import { createAction } from '@reduxjs/toolkit'
import { MyRewardType, RankingItemType, RewardType } from './type'

export const fetchRewardSuccess = createAction<RewardType[]>('reward/fetchRewardSuccess')
export const setMyRewardsData = createAction<MyRewardType[]>('reward/setMyRewardsData')
export const setRankingsData = createAction<RankingItemType[]>('reward/setRankingsData')
